import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./ServicesStyle";
import Services1 from '../../components/services/services/index'
const ServicesPage = React.memo((props) => {
  return (
    <>
      <Services1 />
    </>
  );
});

export default withRouter(ServicesPage);
